import { render, staticRenderFns } from "./SkillsLevelsComparisonRecap.vue?vue&type=template&id=89c99878&scoped=true"
import script from "./SkillsLevelsComparisonRecap.vue?vue&type=script&lang=js"
export * from "./SkillsLevelsComparisonRecap.vue?vue&type=script&lang=js"
import style0 from "./SkillsLevelsComparisonRecap.vue?vue&type=style&index=0&id=89c99878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c99878",
  null
  
)

export default component.exports